import axios from "axios";
//GET ALL CARCATAGORY BY COUNTRY
export const CANCEL_QUOTATION_CASES = "CANCEL_QUOTATION_CASES";
export const CANCEL_QUOTATION_CASES_LOADING =
"CANCEL_QUOTATION_CASES_LOADING";
export const CANCEL_QUOTATION_CASES_LOADING_FAILED =
"CANCEL_QUOTATION_CASES_LOADING_FAILED";

// HELPER ACTIONS CREATORS
//************************************** /

export const cancelQuotationLoading = ms => ({
    type: CANCEL_QUOTATION_CASES_LOADING,
    payload: ms
    });
    
    export const cancelQuotationLoadingFailed = ms => ({
    type: CANCEL_QUOTATION_CASES_LOADING_FAILED,
    payload: ms
    });

// RIDER PHINE NUBER
export function cancelQuotation(id) {
  /* ${process.env.REACT_APP_FILE}/accountRoutes/api/v1/caseQuotations/getCountOfQuotation  */
    const request = axios.delete(
      `${process.env.REACT_APP_FILE}/accountRoutes/api/v1/caseQuotations/cancelQuotation/${id}`,
      {
        headers: { 'Authorization': 'bearer ' +localStorage.accountantToken}
      });

    return dispatch => {

    dispatch(cancelQuotationLoading());
 
    request
    .then(response => {   
      console.log(response,"response, cancel quotation")   
    if (response.status == 200) {
    dispatch({
    type: CANCEL_QUOTATION_CASES,
    payload: response.data
    });
  
    } else {
      
    throw new Error(JSON.stringify(response.data.response.msg));
    }
    })
    .catch(error => {
        
    if (error.response) {
    if (error.response.status == "404") {
        console.log(error.response)
    dispatch(
        cancelQuotationLoadingFailed(error.response.data.message)
    );
    } else {
    dispatch(cancelQuotationLoadingFailed(error.response.data.message));
    }
    console.log(error.response.data);
    console.log(error.response.status);
    console.log(error.response.headers);
    } else if (error.request) {
    /*
    * The request was made but no response was received, `error.request`
    * is an instance of XMLHttpRequest in the browser and an instance
    * of http.ClientRequest in Node.js
    */
    dispatch(cancelQuotationLoadingFailed(error.request));
    
    console.log(error.request);
    } else {
    // Something happened in setting up the request and triggered an Error
    console.log("Error", error.message);
    dispatch(cancelQuotationLoadingFailed(error.message));
    }
    console.log(error);
    });
    };
    }


